/**
 * DexieAdapter — NotenDatabase를 ILocalDatabase로 래핑
 *
 * 기존 Dexie 인스턴스의 모든 테이블을 DexieTableAdapter로 감싸서
 * ILocalDatabase 인터페이스를 구현.
 */

import type { NotenDatabase } from "../client";
import type { ILocalDatabase } from "../interfaces";
import { DexieTableAdapter } from "./DexieTableAdapter";

export function createDexieAdapter(db: NotenDatabase): ILocalDatabase {
  return {
    sessions: new DexieTableAdapter(db.sessions),
    syncState: new DexieTableAdapter(db.syncState),
    cachedSessionTypes: new DexieTableAdapter(db.cachedSessionTypes),
    cachedStudents: new DexieTableAdapter(db.cachedStudents),
    cachedTeachers: new DexieTableAdapter(db.cachedTeachers),
    cachedPermissions: new DexieTableAdapter(db.cachedPermissions),
    cachedSettings: new DexieTableAdapter(db.cachedSettings),
    cachedThemes: new DexieTableAdapter(db.cachedThemes),
    cachedHolidays: new DexieTableAdapter(db.cachedHolidays),
    cachedProfiles: new DexieTableAdapter(db.cachedProfiles),
    cachedFlows: new DexieTableAdapter(db.cachedFlows),
    cachedCourses: new DexieTableAdapter(db.cachedCourses),
    cachedClassrooms: new DexieTableAdapter(db.cachedClassrooms),
    cachedBranches: new DexieTableAdapter(db.cachedBranches),
    cachedAcademyInfo: new DexieTableAdapter(db.cachedAcademyInfo),
    cachedScheduleTemplates: new DexieTableAdapter(db.cachedScheduleTemplates),
    cachedExams: new DexieTableAdapter(db.cachedExams),
    cachedStudentStats: new DexieTableAdapter(db.cachedStudentStats),
    cachedSchools: new DexieTableAdapter(db.cachedSchools),
    cachedTextbooks: new DexieTableAdapter(db.cachedTextbooks),
    cachedTodos: new DexieTableAdapter(db.cachedTodos),
    cachedNotebooks: new DexieTableAdapter(db.cachedNotebooks),
    cachedScores: new DexieTableAdapter(db.cachedScores),
    cachedQuestions: new DexieTableAdapter(db.cachedQuestions),
    cachedQuestionSets: new DexieTableAdapter(db.cachedQuestionSets),
    cachedQuestionLinks: new DexieTableAdapter(db.cachedQuestionLinks),
    cachedConceptNodes: new DexieTableAdapter(db.cachedConceptNodes),
    cachedExamPapers: new DexieTableAdapter(db.cachedExamPapers),
    cachedChannels: new DexieTableAdapter(db.cachedChannels),
    cachedChannelMessages: new DexieTableAdapter(db.cachedChannelMessages),
    pendingMutations: new DexieTableAdapter(db.pendingMutations),
  };
}
